import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "vf_admin_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => localStorage.setItem(KEY, t);
export const clearToken = () => localStorage.removeItem(KEY);

export const authApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};
